import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";

import { validateVAT } from "helpers/aedevat";
import PropTypes from "prop-types"


const VATModal = ({ValidData}) => {

  const [modal, setModal] = useState(false);
  const [vatNumber, setVatNumber] = useState("");
  const [companyDetails, setCompanyDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [validationResult, setValidationResult] = useState(null);
  const toggle = () => setModal(!modal);
  const handleVatNumberChange = (event) => {
    setVatNumber(event.target.value);
  };



  const handleValidation = async () => {
    setCompanyDetails()
    try {
     // const response =54// await fetch(`https://vat.erply.com/numbers?vatNumber=${vatNumber}`);
      const response = await validateVAT(vatNumber)
      //console.log(test)
      
      const data = response.data;

      if (response.success) {
        setValidationResult(data);
        console.log(data)
        setCompanyDetails(data)
        setValidationResult(null);

      }
    } catch (error) {
      console.error('Error validating VAT:', error);
      setValidationResult(null);
      alert('An error occurred while validating VAT number.Propably not excist');
    }
  };


  return (
    <>
      <Button color="primary" onClick={toggle}>
        VAT Validation
      </Button>
     
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Validate VAT</ModalHeader>
        <ModalBody>
          <Input
            type="text"
            placeholder="Enter VAT Number"
            value={vatNumber}
            onChange={handleVatNumberChange}
          />
          {loading ? (
            <p>Loading...</p>
          ) : companyDetails ? (
            <div>
                   <p>{companyDetails.basicInfo.deactivation_flag_descr}--{companyDetails.basicInfo.afm}</p>
             
              <p>{companyDetails.basicInfo.onomasia}</p>
              <p>{companyDetails.basicInfo.postal_address}-{companyDetails.basicInfo.postal_zip_code}--{companyDetails.basicInfo.postal_area_description} </p>
              
            
            </div>
          ) : (
            <p>No company details found.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleValidation}>
            Validate
          </Button>{" "}
          <Button color="primary" onClick={() => { 
            ValidData(companyDetails)
            setModal(false)}}>
            Update Company 
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

VATModal.propTypes = {
  ValidData: PropTypes.func,
}

export default VATModal;
